<template>
  <div class="report-container">
    <!-- <header class="logo-header">
      <div class="logo-wrapper">
        <div class="logo-text">
          <span class="main-title">富士康大学</span>
          <span class="sub-title">Foxconn University</span>
        </div>
      </div>
    </header> -->

    <main class="content-main">
      <div class="title-section">
        <h1 class="main-title-text">披荆斩棘</h1>
        <h2 class="sub-title-text">
          <span class="memo-icon">📝</span>每一次都是笃定的回响
        </h2>
      </div>

      <div class="data-card">
        <div class="report-paragraph">
          <p class="report-line">
            上半年你一共迎战了 <span class="highlight-num">{{ ReportData.examTimes }}</span> 次考试。
          </p>
          <p class="report-line" v-if="ReportData.coursenumF > 0 || ReportData.coursenumF != null">
            其中有 <span class="highlight-num">{{ ReportData.coursenumF }}</span> 门课程实现了<span class="quote-text">“一次通关”</span>！
          </p>
          <p class="badge-line">
            <span class="highlight-badge">高光时刻，无可替代</span>
          </p>
        </div>

        <div class="report-paragraph delay-1" v-if="ReportData.rate5 > 0 || ReportData.rate5 !== null">
          <p class="report-line">
            在这场知识的通关战中，
          </p>
          <p class="report-line">
            你成功打败了 <span class="highlight-num percent">{{ ReportData.rate5 }}%</span> 的共同迎战者。
          </p>
        </div>

        <div class="report-paragraph delay-2">
          <p class="report-line emphasis-line">
            每一次落笔，
          </p>
          <p class="report-line emphasis-line">
            都是你对专业实力的温柔证明。
          </p>
        </div>
      </div>
    </main>

    <div class="floating-line"></div>
  </div>
</template>

<script>
export default {
  name: 'ReportExamPage',
   props: ["ReportData"],
  data() {
    return {
      // 考试相关动态数据，可根据后台接口渲染
      examCount: 8,         // 迎战考试次数
      passOnceCount: 6,     // 一次通关门数
      beatPercent: '92.8'   // 打败迎战者比例
    }
  }
}
</script>

<style scoped>
/* 基础容器与背景配置 */
.report-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  padding: 30px 24px;
  /* 使用你指定的蓝色系原图背景，不增加额外遮罩层 */
  background: 
    url("../../assets/26June/logo.png") right top no-repeat,
    url("../../assets/26June/bg.jpg") no-repeat;
  background-size: 100% 100%, cover;
  font-family: -apple-system, "SF Pro Text", "PingFang SC", sans-serif;
  display: flex;
  flex-direction: column;
}

/* 主体内容布局 */
.content-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  z-index: 2;
  margin-top: 30px;
}

/* 标题区域 */
.title-section {
  margin-bottom: 25px;
  animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}
.main-title-text {
  font-size: 34px;
  font-weight: 900;
  margin: 0;
  letter-spacing: 4px;
  color: #004d40; /* 高级沉稳的墨绿蓝 */
}
.sub-title-text {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #1e293b;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
}
.memo-icon {
  font-size: 19px;
  margin-right: 6px;
  animation: pulse 2s infinite ease-in-out;
}

/* 高透光白色毛玻璃卡片：完美承载深色字，同时保留背景的透光蓝 */
.data-card {
  background: rgba(255, 255, 255, 0.48);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 24px;
  padding: 30px 22px;
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.12);
}

/* 段落间距与动画 */
.report-paragraph {
  margin-bottom: 28px;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.report-paragraph:last-child {
  margin-bottom: 0;
}
.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }

/* 报告文本基本样式 */
.report-line {
  font-size: 16px;
  line-height: 1.7;
  margin: 0;
  color: #1e293b; /* 优雅的深灰蓝，保障100%可读性 */
  letter-spacing: 0.8px;
}
.quote-text {
  font-weight: 600;
  color: #004d40;
}

/* “高光时刻”独立徽章样式 */
.badge-line {
  margin: 10px 0 0 0;
}
.highlight-badge {
  display: inline-block;
  background: linear-gradient(135deg, #00695c, #004d40);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  padding: 3px 12px;
  border-radius: 6px;
  letter-spacing: 1px;
  box-shadow: 0 4px 10px rgba(0, 77, 64, 0.2);
}

/* 数字焦点高亮（琥珀橙金，蓝黄经典互补） */
.highlight-num {
  font-size: 28px;
  font-weight: 700;
  font-family: "DIN Alternate", "Helvetica Neue", sans-serif;
  color: #e65100; 
  margin: 0 4px;
  display: inline-block;
}
.highlight-num.percent {
  color: #d84315; 
}

/* 结尾情感金句加粗强调 */
.emphasis-line {
  font-weight: 700;
  color: #0f172a; /* 极深蓝黑，增强顿挫感与厚重感 */
  margin-top: 6px;
  font-size: 16.5px;
}

/* 装饰性右下角光纤线条 */
.floating-line {
  position: absolute;
  right: -15px;
  bottom: 22%;
  width: 100px;
  height: 2px;
  background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,0.5), rgba(255,255,255,0));
  transform: rotate(-35deg);
  pointer-events: none;
}

/* --- 细腻动效 --- */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-15px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.15); }
}

/* 小屏手机适配 */
@media screen  and (max-height: 670px) {
  .report-line { font-size: 15px; letter-spacing: 0.2px;}
  .highlight-num { font-size: 24px; }
  .main-title-text { font-size: 28px; }
  .sub-title-text { font-size: 19px; }
  .data-card { padding: 12px 18px; }
}

/* PC 端自适应沙盒模拟 */
@media screen and (min-width: 1024px) {
  .report-container {
    width: 100% !important;
    height: 100vh !important;
    padding: 60px 10%; /* 侧边增加安全留白，防止内容贴边 */
    
    /* 单一背景图完美全屏铺满，不留任何死角 */
    background-image: url("../../assets/26June/pcbg.png") !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important; /* 核心：等比例拉伸，宁可裁剪也绝不留白 */
    
    /* 彻底移除手机端的圆角和边界阴影 */
    border-radius: 0 !important;
    box-shadow: none !important;
    border: none !important;
  }

}
</style>